/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Meta_DescriptionInputs */

const en_auth_meta_description = /** @type {(inputs: Auth_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in to manage your lesson bookings with Mark Egly Golf.`)
};

const es_auth_meta_description = /** @type {(inputs: Auth_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inicia sesión para administrar tus reservas de lecciones con Mark Egly Golf.`)
};

const de_auth_meta_description = /** @type {(inputs: Auth_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Melden Sie sich an, um Ihre Unterrichtsbuchungen bei Mark Egly Golf zu verwalten.`)
};

const zh_auth_meta_description = /** @type {(inputs: Auth_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`登录以管理你在 Mark Egly Golf 的课程预订。`)
};

const ar_auth_meta_description = /** @type {(inputs: Auth_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سجّل الدخول لإدارة حجوزات دروسك مع Mark Egly Golf.`)
};

const fr_auth_meta_description = /** @type {(inputs: Auth_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connectez-vous pour gérer vos réservations de cours avec Mark Egly Golf.`)
};

const vi_auth_meta_description = /** @type {(inputs: Auth_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đăng nhập để quản lý đặt bài học với Mark Egly Golf.`)
};

const sw_auth_meta_description = /** @type {(inputs: Auth_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingia katika akaunti ili kudhibiti uhifadhi wa somo lako ukitumia Mark Egly Golf.`)
};

const th_auth_meta_description = /** @type {(inputs: Auth_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ลงชื่อเข้าใช้เพื่อจัดการการจองบทเรียนกับ Mark Egly Golf`)
};

const bs_auth_meta_description = /** @type {(inputs: Auth_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prijavite se da upravljate rezervacijama lekcija kod Mark Egly Golf.`)
};

const ja_auth_meta_description = /** @type {(inputs: Auth_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly Golfのレッスン予約を管理するにはサインインしてください。`)
};

const ko_auth_meta_description = /** @type {(inputs: Auth_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly Golf 레슨 예약을 관리하려면 로그인하세요.`)
};

const pt_auth_meta_description = /** @type {(inputs: Auth_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entre para gerenciar suas reservas de aula com a Mark Egly Golf.`)
};

const it_auth_meta_description = /** @type {(inputs: Auth_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accedi per gestire le tue prenotazioni di lezioni con Mark Egly Golf.`)
};

const sv_auth_meta_description = /** @type {(inputs: Auth_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logga in för att hantera dina lektionsbokningar hos Mark Egly Golf.`)
};

const nl_auth_meta_description = /** @type {(inputs: Auth_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Log in om je lesboekingen bij Mark Egly Golf te beheren.`)
};

const da_auth_meta_description = /** @type {(inputs: Auth_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Log ind for at administrere dine lektionsbookinger hos Mark Egly Golf.`)
};

const nb_auth_meta_description = /** @type {(inputs: Auth_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logg inn for å administrere timebestillingene dine hos Mark Egly Golf.`)
};

const fi_auth_meta_description = /** @type {(inputs: Auth_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kirjaudu sisään ja hallitse Mark Egly Golfin tuntivarauksiasi.`)
};

const pl_auth_meta_description = /** @type {(inputs: Auth_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zaloguj się, aby zarządzać rezerwacjami lekcji w Mark Egly Golf.`)
};

const ru_auth_meta_description = /** @type {(inputs: Auth_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Войдите, чтобы управлять бронированиями уроков в Mark Egly Golf.`)
};

const tr_auth_meta_description = /** @type {(inputs: Auth_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ders rezervasyonlarınızı Mark Egly Golf ile yönetmek için oturum açın.`)
};

const hi_auth_meta_description = /** @type {(inputs: Auth_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly Golf के साथ अपनी पाठ बुकिंग का प्रबंधन करने के लिए साइन इन करें।`)
};

const id_auth_meta_description = /** @type {(inputs: Auth_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masuk untuk mengelola pemesanan pelajaran Anda di Mark Egly Golf.`)
};

const ms_auth_meta_description = /** @type {(inputs: Auth_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Log masuk untuk mengurus tempahan pelajaran anda dengan Mark Egly Golf.`)
};

const cs_auth_meta_description = /** @type {(inputs: Auth_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přihlaste se a spravujte své rezervace lekcí u Mark Egly Golf.`)
};

const el_auth_meta_description = /** @type {(inputs: Auth_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Συνδεθείτε για να διαχειρίζεστε τις κρατήσεις μαθημάτων σας στο Mark Egly Golf.`)
};

const he_auth_meta_description = /** @type {(inputs: Auth_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`התחברו כדי לנהל את הזמנות השיעורים שלכם ב-Mark Egly Golf.`)
};

const af_auth_meta_description = /** @type {(inputs: Auth_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meld aan om jou lesbesprekings by Mark Egly Golf te bestuur.`)
};

const hu_auth_meta_description = /** @type {(inputs: Auth_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jelentkezzen be a Mark Egly Golfnál foglalt óráinak kezeléséhez.`)
};

/**
* | output |
* | --- |
* | "Sign in to manage your lesson bookings with Mark Egly Golf." |
*
* @param {Auth_Meta_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const auth_meta_description = /** @type {((inputs?: Auth_Meta_DescriptionInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Meta_DescriptionInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_auth_meta_description(inputs)
	if (locale === "de") return de_auth_meta_description(inputs)
	if (locale === "zh") return zh_auth_meta_description(inputs)
	if (locale === "ar") return ar_auth_meta_description(inputs)
	if (locale === "fr") return fr_auth_meta_description(inputs)
	if (locale === "vi") return vi_auth_meta_description(inputs)
	if (locale === "sw") return sw_auth_meta_description(inputs)
	if (locale === "th") return th_auth_meta_description(inputs)
	if (locale === "bs") return bs_auth_meta_description(inputs)
	if (locale === "ja") return ja_auth_meta_description(inputs)
	if (locale === "ko") return ko_auth_meta_description(inputs)
	if (locale === "pt") return pt_auth_meta_description(inputs)
	if (locale === "it") return it_auth_meta_description(inputs)
	if (locale === "sv") return sv_auth_meta_description(inputs)
	if (locale === "nl") return nl_auth_meta_description(inputs)
	if (locale === "da") return da_auth_meta_description(inputs)
	if (locale === "nb") return nb_auth_meta_description(inputs)
	if (locale === "fi") return fi_auth_meta_description(inputs)
	if (locale === "pl") return pl_auth_meta_description(inputs)
	if (locale === "ru") return ru_auth_meta_description(inputs)
	if (locale === "tr") return tr_auth_meta_description(inputs)
	if (locale === "hi") return hi_auth_meta_description(inputs)
	if (locale === "id") return id_auth_meta_description(inputs)
	if (locale === "ms") return ms_auth_meta_description(inputs)
	if (locale === "cs") return cs_auth_meta_description(inputs)
	if (locale === "el") return el_auth_meta_description(inputs)
	if (locale === "he") return he_auth_meta_description(inputs)
	if (locale === "af") return af_auth_meta_description(inputs)
	if (locale === "hu") return hu_auth_meta_description(inputs)
	return en_auth_meta_description(inputs)
});